import axios from "axios";
import {
  PENJUALAN_CABANG_GET_FAIL,
  PENJUALAN_CABANG_GET_REQUEST,
  PENJUALAN_CABANG_GET_RESET,
  PENJUALAN_CABANG_GET_SUCCESS,
} from "../constants/PenjualanCabangConstants";
import {
  API_PENJUALAN_CABANG_GET,
  API_PENJUALAN_CABANG_GET_DOWNLOAD,
} from "../init/api_url";
import { Logout } from "../../loginModul/actions/loginAction";
import { ActGeneralButtonDownloadSuccess } from "../../../general/components/button/ButtonDownloadsrc/action";

export const DownloadGetPenjualanCabang =
  ({ dateStart, dateEnd, outlet, namaOutlet }) =>
  async (dispatch, getState) => {
    let fileName = "Penjualan " + namaOutlet + ".xlsx";
    const {
      userLogin: { token },
    } = getState();
    const data = await axios({
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: API_PENJUALAN_CABANG_GET_DOWNLOAD,
      method: "GET",
      responseType: "blob", // important
      params: {
        startDate: dateStart,
        endDate: dateEnd,
        outlet: outlet,
      },
    });
    console.log("Download Data", data["Content-Disposition"], data);
    const url = window.URL.createObjectURL(new Blob([data.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    dispatch(ActGeneralButtonDownloadSuccess());
  };

export const GetPenjualanCabang =
  ({ dateStart, dateEnd, outlet }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: PENJUALAN_CABANG_GET_REQUEST,
      });
      const {
        userLogin: { token },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          startDate: dateStart,
          endDate: dateEnd,
          outlet: outlet,
        },
      };
      const { data: data } = await axios.get(API_PENJUALAN_CABANG_GET, config);
      console.log("testing Action get penjualan", data);
      dispatch({
        type: PENJUALAN_CABANG_GET_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response.status == 401) {
        dispatch(Logout());
      }
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: PENJUALAN_CABANG_GET_FAIL,
        payload: message,
      });
    }
  };

export const RGetPenjualanCabang = () => async (dispatch, getState) => {
  dispatch({
    type: PENJUALAN_CABANG_GET_RESET,
  });
};
